<template>
  <voice-select activatorClass='tts-voice-selector' :open='open' :voices='voices' :voice='voice' @voice-changed='handleVoiceChanged' @menu-opened='handleMenuOpened'/>
</template>

<script>
import { inject, defineComponent } from 'vue';
import { useEvent } from '../../plugins/vue-gtag';
import { debounce } from '../../utils/events';
import VoiceSelect from './VoiceSelect.vue';

export default defineComponent({
  components: {
    VoiceSelect,
  },
  props: ['open'],
  setup(_, context){
    const voices = inject('voices');
    const voice = inject('voice');
    const changeVoice = inject('handleVoiceChanged');
    const gaVoiceChange = useEvent('voice_changed_tts');
    const gaVoiceMenuOpened = debounce(useEvent('voice_menu_opened_tts'), 500);

    const handleVoiceChanged = (...args)=>{
      changeVoice(...args)
      gaVoiceChange(voice.value.voiceURI);
    }

    const handleMenuOpened = (newVal)=>{
      gaVoiceMenuOpened(newVal);
      context.emit('update:open', newVal);
    }

    return {
      voice,
      voices,
      handleVoiceChanged,
      handleMenuOpened
    }
  }
})
</script>